import styles from './bancosaldo.module.css';
import ui from "../../styles/ui.module.css";
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { CgAdd } from 'react-icons/cg';
import api, { baseURL } from "../../services/api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from '../../components/Spinner/carregando';
import { FiPlus, FiX } from "react-icons/fi";

const envUrl = (baseURL || '').trim();
const apiBase = envUrl || '/api';

const Banco = () => {
  const dataRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isForm, setIsForm] = useState(false);
  const [bancos, setBancos] = useState([]);
  const [saldos, setSaldos] = useState([]);
  const [dataFiltro, setDataFiltro] = useState(() => new Date().toISOString().slice(0,10));
  const [totais, setTotais] = useState({});
  const [sugestoes, setSugestoes] = useState([]);
  const [mostrarSugestoes, setMostrarSugestoes] = useState(false);
  const [sugestaoSelecionada, setSugestaoSelecionada] = useState(-1);
  const [formData, setFormData] = useState({
    data: "",
    nomeBanco: "",
    saldo: "",
    moeda: "",
  });
  const navigate = useNavigate();

  useEffect(() => {
    const carregarBancos = async () => {
      try {
        const resposta = await api.get("/bancos");
        setBancos(resposta.data);
      } catch (erro) {
        console.error("Erro ao carregar BANCOS", erro);
        toast.error("Erro ao carregar BANCOS.");
      }
    };
    const carregarSaldos = async (dataAlvo) => {
      try {
        const url = dataAlvo ? `/consultas-saldos/saldos?data=${encodeURIComponent(dataAlvo)}` : "/consultas-saldos/saldos";
        const resp = await api.get(url);
        const lista = Array.isArray(resp.data) ? resp.data : [];
        setSaldos(lista.map(s => ({
          ...s,
          SALDO: Number(s.SALDO) || 0,
        })));
        const tot = {};
        lista.forEach(s => {
          const m = String(s.MOEDA || '').toUpperCase();
          const v = Number(s.SALDO) || 0;
          tot[m] = (tot[m] || 0) + v;
        });
        setTotais(tot);
      } catch (erro) {
        console.error("Erro ao carregar saldos", erro);
        toast.error("Erro ao carregar saldos.");
      }
    };
    carregarBancos();
    carregarSaldos(dataFiltro);
    toast.success("Bancos carregados com sucesso!");
  }, []);

  const buscarSaldos = async () => {
    setIsLoading(true);
    try {
      const url = dataFiltro ? `/consultas-saldos/saldos?data=${encodeURIComponent(dataFiltro)}` : "/consultas-saldos/saldos";
      const resp = await api.get(url);
      const lista = Array.isArray(resp.data) ? resp.data : [];
      setSaldos(lista.map(s => ({ ...s, SALDO: Number(s.SALDO) || 0 })));
      const tot = {};
      lista.forEach(s => {
        const m = String(s.MOEDA || '').toUpperCase();
        const v = Number(s.SALDO) || 0;
        tot[m] = (tot[m] || 0) + v;
      });
      setTotais(tot);
    } catch (erro) {
      console.error("Erro ao carregar saldos", erro);
      toast.error("Erro ao carregar saldos.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: name === "saldo" ? parseFloat(value) || 0 : value,
    }));
    if (name === "nomeBanco") {
      const matches = bancos
        .filter((banco) => banco?.NOME?.toLowerCase().includes(value.toLowerCase()))
        .map((banco) => ({
          id: banco.ID_BANCO,
          nome: banco.NOME,
          logo: banco.LOGO_PATH,
          moeda: banco.MOEDA,
        }));
      setSugestoes(matches);
      setMostrarSugestoes(matches.length > 0);
    }
  };

  const handleSugestaoClick = (banco) => {
    setFormData((prevData) => ({
      ...prevData,
      nomeBanco: banco.nome,
      bancoId: banco.id,
      moeda: banco.moeda,
    }));
    setMostrarSugestoes(false);
  };

  const handleKeyDown = (e) => {
    if (mostrarSugestoes && sugestoes.length > 0) {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setSugestaoSelecionada((prev) =>
          prev < sugestoes.length - 1 ? prev + 1 : 0
        );
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setSugestaoSelecionada((prev) =>
          prev > 0 ? prev - 1 : sugestoes.length - 1
        );
      } else if (e.key === "Enter") {
        e.preventDefault();
        if (sugestaoSelecionada >= 0) {
          handleSugestaoClick(sugestoes[sugestaoSelecionada]);
          setSugestaoSelecionada(-1);
        }
      } else if (e.key === "Escape") {
        setMostrarSugestoes(false);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const nomeJaExiste = bancos.some((banco) => banco.NOME === formData.nomeBanco);

    if (!formData.data || !formData.nomeBanco || !nomeJaExiste || !formData.saldo || !formData.moeda) {
      toast.warn("Preencha todos os campos e selecione um dos bancos já cadastrados ou cadastre um!");
      return;
    }

    try {
      setIsLoading(true);
      const novoSaldo = {
        id: formData.bancoId,
        data: formData.data,
        nomeBanco: formData.nomeBanco,
        saldo: formData.saldo,
        moeda: formData.moeda,
      };
      //console.log(novoSaldo);
      await api.post("/consultas-saldos/saldos", novoSaldo);

      toast.success("Saldo cadastrado com sucesso!");

      setFormData({
        data: formData.data,
        nomeBanco: "",
        saldo: "",
        moeda: "",
      });
    } catch (err) {
      //console.log("Erro ao salvar lançamento de saldo: ", err);
      const errorMessage = err.response?.data || "Erro ao lançar saldo";
      toast.error(errorMessage);
    } finally {
      setIsLoading(false)
    }

    if (dataRef.current) {
      dataRef.current.focus();
    }
  };

  const handleNovoBanco = () => {
    setIsForm(true);
  };

  const formatValor = (v) => {
    const n = Number(v) || 0;
    return n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  return (
    <main className={styles.root}>
      {/* Filtro por data e visão dos saldos por banco */}
      <section className={styles['banco-saldos-visao']}>
        <h1 className={`${ui.titg}`}>Saldos por Banco</h1>
        <div className={styles['banco-filtro']} >
          <div>
            <label className={`${ui.labdesktop}`}>Data</label>
            <input
              className={`${ui.inpdesktop}`}
              type="date"
              value={dataFiltro}
              onChange={(e) => setDataFiltro(e.target.value)}
            />
          </div>
          
            <button onClick={buscarSaldos} className={`${ui.butdesktop}`}>Buscar</button>
        
        </div>
        {saldos.length > 0 ? (
          <ul>
            {saldos.map((s, idx) => (
              <li key={`${s.ID_SALDO || s.ID_BANCO || idx}-${idx}`} className={styles['banco-saldo-item']} >
                <img
                  src={
                    s.LOGO_BANCO
                      ? `${apiBase}/logoBanco/${String(s.LOGO_BANCO).split('/').pop()}`
                      : `${apiBase}/logoBanco/123.jpg`
                  }
                  alt={s.NOME_BANCO}
                  style={{ width: '22px', height: '22px' }}
                />
                <span style={{ flex: 1 }}>{s.NOME_BANCO}</span>
                <span>{s.MOEDA}</span>
                <strong>{formatValor(s.SALDO)}</strong>
              </li>
            ))}
          </ul>
        ) : (
          <p>Nenhum saldo encontrado para a data selecionada.</p>
        )}
        {/* Totalizador por moeda */}
        {Object.keys(totais).length > 0 && (
          <div className={styles['banco-totalizador']} style={{ marginTop: '8px' }}>
            <h3 className={`${ui.titg}`}>Totais</h3>
            <div style={{ display: 'flex', gap: '16px' }}>
              {Object.entries(totais).map(([moeda, valor]) => (
                <div key={moeda}><strong>{moeda}:</strong> {formatValor(valor)}</div>
              ))}
            </div>
          </div>
        )}
      </section>
      {isForm ? (
        <div className={`${ui.divnegratelatotal}`}>
          <form onSubmit={handleSubmit} className={styles['banco-formulario-saldo']}>
            <h1 className={`${ui.titg}`}>Cadastrar Saldo</h1>
            <button
              type="button"
              className={`${ui.butfechar}`}
              onClick={() => setIsForm(false)}
              aria-label="Fechar formulário"
              title='Fechar formulário'
            >
              <FiX size={18} />
            </button>
          
          <div>
            <label className={`${ui.labdesktop}`}>Nome do Banco</label>
            <input
              className={`${ui.inpdesktop}`}
              type="text"
              name="nomeBanco"
              value={formData.nomeBanco || ""}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
              placeholder="Digite o nome do banco"
              ref={dataRef}
              required
            />
            {mostrarSugestoes && (
              <ul className={styles['banco-sugestoes']}>
                {sugestoes.map((banco, index) => (
                  <li
                    key={banco.id}
                    onClick={() => handleSugestaoClick(banco)}
                    className={`${styles['banco-sugestao-item']} ${index === sugestaoSelecionada ? styles.selecionada : ''}`}
                  >

                    <img
                      src={
                        banco?.logo
                          ? `${apiBase}/logoBanco/${banco.logo.split('/').pop()}`
                          : `${apiBase}/logoBanco/123.jpg` // URL de uma imagem padrão
                      }
                      alt={banco.nome}
                      style={{ width: "30px", marginRight: "10px" }}
                    />
                    {banco.nome}
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div className={styles['div-data-moeda']}>
            <div>
              <label className={`${ui.labdesktop}`}>Saldo</label>
              <input
              className={`${ui.inpdesktop}`}
                type="text"
                inputMode="decimal"
                name="saldo"
                value={formData.saldo || ""}
                onChange={handleChange}
                placeholder="Digite o saldo"
                required
              />
            </div>
          
            <div>
              <label className={`${ui.labdesktop}`}>Moeda</label>
              <select
                className={`${ui.seldesktop}`}
                name="moeda"
                value={formData.moeda || ""}
                onChange={handleChange}
                required
              >
                <option value="USD">Dolar</option>
                <option value="BRL">Reais</option>
                <option value="BOB">Boliviano</option>
              </select>
            </div>

            <div>
              <label className={`${ui.labdesktop}`}>Data</label>
              <input
                className={`${ui.inpdesktop}`}
                type="date"
                name="data"
                value={formData.data || ""}
                onChange={handleChange}
                required
              />
            </div>

          </div>  
          <div className={`${ui.divbutsalvar}`}>
            <button type="submit" className={`${ui.butdesktop}`}>Cadastrar Saldo</button>
          </div>
        </form>
      </div>
      ) : (
        <div></div>
      )}
      <div className={ui.floatingFab}>
        <button onClick={handleNovoBanco} className={`${ui.novaBtn} ${ui.addBtn} ${styles.bancoFabBtn}` } aria-label="Cadastrar novo banco">
          <FiPlus size={24} />
        </button>
      </div>
      <ToastContainer limit={1} position="top-right" autoClose={2000} />
      <Spinner
        isLoading={isLoading}
      />
    </main>
  );
};

export default Banco;
